import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { InfoBrowserComponent } from './info-browser.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FuseSharedModule } from '@fuse/shared.module';

const routes = [
    {
        path: 'info-browser',
        component: InfoBrowserComponent
    }
];

@NgModule({
    declarations: [InfoBrowserComponent],
    imports: [RouterModule.forChild(routes), TranslateModule, MatButtonModule, MatFormFieldModule, MatIconModule, MatInputModule, FuseSharedModule]
})
export class InfoBrowserModule {}
